import ContactList from "../../features/contacts/components/ContactList";

export default ContactList;
